import { useSelector } from 'react-redux'
import { getUrlPathSelector } from '~/app/store/config/reducer'

export const useGalleryUrl = (): URL => {
  const galleryLink = useSelector(getUrlPathSelector)

  return new URL(typeof galleryLink === 'string' ? galleryLink : galleryLink?.href)
}
